export const indexToColor: { [key: number]: string } = {
  0: "yellow",
  1: "purple",
  2: "sea",
  3: "bruise",
  4: "morning",
  5: "paw",
  6: "pods",
  7: "green",
};

export function getColorByIndex(index: number): string {
  const position = index % Object.keys(indexToColor).length;

  return indexToColor[position];
}
